import { useCallback, useMemo } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client';
import { t } from 'ttag';

import { socialSimilarFeed } from '@urls';
import { useViewer } from '@hook/useViewer';
import { ProfileSocialPostsFeed } from '@components/profile/ProfileSocialPostsFeed';

import { useProfileSocialPostsQuery } from './gql/graphql.v5.generated';

type Params = {
  username?: string
};
export const ProfileSocialPostsContainer = () => {
  const history = useHistory();
  const { username } = useParams<Params>();

  const { viewer } = useViewer();

  const { data: postsData, networkStatus, fetchMore } = useProfileSocialPostsQuery({
    variables: {
      username: username as string,
    },
    context: {
      v5: true,
      batch: true,
    },
    notifyOnNetworkStatusChange: true,
    skip: !username,
  });

  const pageInfo = postsData?.user?.posts?.pageInfo;

  const handleLoadMore = useCallback(async () => {
    if (pageInfo?.hasNextPage && networkStatus === NetworkStatus.ready) {
      await fetchMore({
        variables: {
          after: pageInfo?.endCursor,
        },
      });
    }
  }, [fetchMore, networkStatus, pageInfo?.endCursor, pageInfo?.hasNextPage]);

  const posts = useMemo(() => {
    const resultPosts = postsData?.user?.posts.edges
      .map(({ node }) => node)
      .filter((post) => post.mediasUrls.length) || [];

    return resultPosts;
  }, [postsData?.user?.posts.edges]);

  const emptyTitle = viewer?.id === postsData?.user?.id
    ? t`Тут з’являться ваші відгуки з фото після покупки на Шафі`
    : t`Тут з’являться відгуки з фото користувача після покупки на Шафі`;
  
  const emptyLink = viewer?.id === postsData?.user?.id ? ({
    title: t`До покупок`,
    pathname: history.createHref({ pathname: '/' }),
  }) : null;

  return (
    <ProfileSocialPostsFeed
      posts={posts}
      isLoading={networkStatus === NetworkStatus.loading}
      emptyTitle={emptyTitle}
      emptyLink={emptyLink}
      hasNextPage={!!pageInfo?.hasNextPage}
      getPostUrl={(post) => generatePath(socialSimilarFeed, { postId: post.id })}
      onLoadMore={handleLoadMore}
    />
  );
};
